import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, ArrowRight } from "lucide-react";

// Promo visible window: 27 May 2026 → 2 June 2026 (Canary Islands Day = 30 May)
const SHOW_FROM = new Date("2026-05-27T00:00:00").getTime();
const SHOW_UNTIL = new Date("2026-06-02T23:59:59").getTime();
const LS_KEY = "lw_canarias_day_popup_v1";

const CanariasDayPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const now = Date.now();
    if (now < SHOW_FROM || now > SHOW_UNTIL) return;
    if (sessionStorage.getItem(LS_KEY) === "seen") return;
    const t = setTimeout(() => setOpen(true), 900);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    sessionStorage.setItem(LS_KEY, "seen");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center px-4 py-6 bg-black/80 backdrop-blur-sm animate-fade-in"
      data-testid="canarias-day-popup"
      onClick={close}
    >
      <div
        className="relative w-full max-w-md sm:max-w-lg max-h-[92vh] overflow-y-auto overflow-x-hidden rounded-3xl border border-[#7DD500]/30 bg-[#0A0A0A] shadow-[0_30px_120px_rgba(125,213,0,0.25)] animate-pop-in scrollbar-thin"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={close}
          data-testid="canarias-day-popup-close"
          aria-label="Cerrar"
          className="absolute top-3 right-3 z-20 w-9 h-9 flex items-center justify-center rounded-full bg-black/60 backdrop-blur text-white/80 hover:bg-black hover:text-white transition"
        >
          <X className="w-4 h-4" strokeWidth={2.5} />
        </button>

        <div className="relative">
          <img
            src="/canarias-day-2026/hero-v10-story-final.png"
            alt="Día de Canarias — LiveWifi Travel"
            className="w-full max-h-[78vh] object-contain object-center block bg-[#0A0A0A]"
            loading="eager"
          />
          <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#0A0A0A] to-transparent pointer-events-none" />
        </div>

        <div className="relative px-5 sm:px-6 pb-5 pt-3 z-10">
          <div className="flex flex-col sm:flex-row gap-2">
            <Link
              to="/lanzamiento-travel"
              onClick={close}
              data-testid="canarias-day-popup-cta"
              className="group flex-1 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-[#7DD500] text-black font-black text-sm hover:bg-[#95E619] transition-all shadow-[0_0_30px_rgba(125,213,0,0.4)]"
            >
              Aprovechar promo
              <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
            </Link>
            <button
              onClick={close}
              data-testid="canarias-day-popup-later"
              className="px-5 py-3 rounded-full border border-white/15 bg-white/[0.03] text-white/60 font-semibold text-sm hover:bg-white/[0.06] hover:text-white transition-all"
            >
              Ahora no
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fade-in { from { opacity: 0 } to { opacity: 1 } }
        @keyframes pop-in {
          from { opacity: 0; transform: translateY(20px) scale(0.96) }
          to { opacity: 1; transform: translateY(0) scale(1) }
        }
        .animate-fade-in { animation: fade-in .25s ease-out both }
        .animate-pop-in { animation: pop-in .35s cubic-bezier(.2,.9,.3,1.2) both }
      `}</style>
    </div>
  );
};

export default CanariasDayPopup;
